import React from 'react';

export interface StylePropType {
    style?: React.CSSProperties;
    className?: string;
}

export interface RadiusPropType {
    radius?: boolean | number | string;
    round?: boolean;
}

export interface RectPropType {
    width?: number;
    height?: number;
}

export function getStyle(props: any) {
    var styleObj:any = {};
    if (props.style) {
        styleObj = Object.assign(styleObj, props.style);
    }
    if (typeof(props.radius) == 'string') {
        styleObj.borderRadius = props.radius;
    } else if (typeof(props.radius) == 'number') {
        styleObj.borderRadius = props.radius + 'px';
    }
    if (!!props.width) {
        styleObj.width = props.width + 'px';
    }
    if (!!props.height) {
        styleObj.height = props.height + 'px';
    }
    return styleObj;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/propType.ts